const _temp0 = require("./screens/404/index.coffee");
const _temp1 = require("./screens/home/index.coffee");
const _temp2 = require("./screens/volunteers/index.coffee");
module.exports = {
  "404": _temp0,
  "home": _temp1,
  "volunteers": _temp2
}